module.exports = __webpack_public_path__ + "img/--09.957af4d1.png";